export const ENTITY_PROFILE_HEADER_TEXT_CLAMP_LINES = 2
